import {
    GET_PRODUCTS_PENDING,
    GET_PRODUCTS_FULFULLED,
    GET_PRODUCTS_REJECTED,
    GET_PRODUCT_PENDING,
    GET_PRODUCT_FULFULLED,
    GET_PRODUCT_REJECTED,
    DELETE_PRODUCT_PENDING,
    DELETE_PRODUCT_FULFILLED,
    DELETE_PRODUCT_REJECTED,
    CREATE_PRODUCT_PENDING,
    CREATE_PRODUCT_FULFILLED,
    CREATE_PRODUCT_REJECTED,
    ADD_SEGMENT_TO_PRODUCT_PENDING,
    ADD_SEGMENT_TO_PRODUCT_FULFILLED,
    ADD_SEGMENT_TO_PRODUCT_REJECTED,
    REMOVE_SEGMENT_FROM_PRODUCT_PENDING,
    REMOVE_SEGMENT_FROM_PRODUCT_FULFILLED,
    REMOVE_SEGMENT_FROM_PRODUCT_REJECTED,
    UPDATE_PRODUCT_PENDING,
    UPDATE_PRODUCT_FULFILLED,
    UPDATE_PRODUCT_FAILED
} from '../actions/ProductActions';

// INITIALIZE STATE
const initialState = {
    products: [],
    product: {},
    fetchingProducts: false,
    fetchedProducts: false,
    failedProducts: false,
    fetchingProduct: false,
    fetchedProduct: false,
    failedProduct: false,
    deletingProducts: false,
    uploadingProducts: false,
    uploadedProducts: false,
    deletedProduct: false,
    addingSegmentToProduct: false,
    addedSegmentToProduct: false,
    addSegmentToProductFailed: false,
    removingSegmentFromProduct: false,
    removedSegmentFromProduct: false,
    removeSegmentFromProductFailed: false,
    updateProductPending: false,
    updateProductFulfilled: false,
    updateProductFailed: false
};

export const ProductReducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_PRODUCTS_PENDING:
            return {
                ...state,
                fetchingProducts: true,
                fetchedProducts: false,
                failedProducts: false
            };
        case GET_PRODUCTS_FULFULLED:
            return {
                ...state,
                products: action.payload,
                fetchingProducts: false,
                fetchedProducts: true,
                failedProducts: false,
            };
        case GET_PRODUCTS_REJECTED:
            return {
                ...state,
                fetchingProducts: false,
                fetchedProducts: false,
                failedProducts: true,
            };
        case GET_PRODUCT_PENDING:
            return {
                ...state,
                product: {},
                fetchingProduct: true,
                fetchedProduct: false,
                failedProduct: false
            };
        case GET_PRODUCT_FULFULLED:
            return {
                ...state,
                product: action.payload,
                fetchingProduct: false,
                fetchedProduct: true,
                failedProduct: false
            };
        case GET_PRODUCT_REJECTED:
            return {
                ...state,
                fetchingProduct: false,
                fetchedProduct: false,
                failedProduct: true
            };
        case DELETE_PRODUCT_PENDING:
            return {
                ...state,
                deletingProducts: true,
                deletedProducts: false,
                rejected: false
            };
        case DELETE_PRODUCT_FULFILLED: {
            let products = state.products.filter(item => item.id !== action.payload);
            return {
                ...state,
                products: products,
                deletingProducts: false,
                deletedProducts: true,
                rejected: false
            };
        }
        case DELETE_PRODUCT_REJECTED:
            return {
                ...state,
                deletingProducts: false,
                deletedProducts: false,
                failedProducts: true,
            };
        case CREATE_PRODUCT_PENDING:
            return {
                ...state,
                uploadingProducts: true,
                uploadedProducts: false,
                rejected: false,
            };
        case CREATE_PRODUCT_FULFILLED:
            return {
                ...state,
                uploadedProducts: true,
                uploadingProducts: false,
                rejected: false
            };
        case CREATE_PRODUCT_REJECTED:
            return {
                ...state,
                uploadedProducts: false,
                uploadingProducts: false,
                rejected: true
            };
        case ADD_SEGMENT_TO_PRODUCT_PENDING: 
            return {
                ...state,
                addingSegmentToProduct: true,
                addedSegmentToProduct: false,
                addSegmentToProductFailed: false
            };
        case ADD_SEGMENT_TO_PRODUCT_FULFILLED: {
            let product = JSON.parse(JSON.stringify(state.product));
            if(product != {}){
                for(let segment of action.payload.segmentIds){
                    if (product.segments == undefined || product.segments == null) {
                        product.segments = {};
                        product.segments[segment] = true;
                    } else {
                        product.segments[segment] = true;
                    }
                }
            }
            return {
                ...state,
                product: product,
                addingSegmentToProduct: false,
                addedSegmentToProduct: true,
                addSegmentToProductFailed: false
            };
        }
        case ADD_SEGMENT_TO_PRODUCT_REJECTED:
            return {
                ...state,
                addingSegmentToProduct: false,
                addedSegmentToProduct: false,
                addSegmentToProductFailed: true
            };
        case REMOVE_SEGMENT_FROM_PRODUCT_PENDING:
            return {
                ...state,
                removingSegmentFromProduct: true,
                removedSegmentFromProduct: false,
                removeSegmentFromProductFailed: false
            };
        case REMOVE_SEGMENT_FROM_PRODUCT_FULFILLED:
            return {
                ...state,
                removingSegmentFromProduct: false,
                removedSegmentFromProduct: true,
                removeSegmentFromProductFailed: false
            };
        case REMOVE_SEGMENT_FROM_PRODUCT_REJECTED:
            return {
                ...state,
                removingSegmentFromProduct: false,
                removedSegmentFromProduct: false,
                removeSegmentFromProductFailed: true
            };
        case UPDATE_PRODUCT_PENDING:
            return {
                ...state,
                updateProductPending: true,
                updateProductFulfilled: false,
                updateProductFailed: false
            };
        case UPDATE_PRODUCT_FULFILLED: {
            return {
                ...state,
                product: action.payload,
                updateProductPending: true,
                updateProductFulfilled: false,
                updateProductFailed: false
            };
        }
        case UPDATE_PRODUCT_FAILED:
            return {
                ...state,
                updateProductPending: false,
                updateProductFulfilled: false,
                updateProductFailed: true
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/components/state/reducers/ProductReducer.js